import { combineReducers } from "redux";
import { reducer as formReducer } from "redux-form";
import { cognito, refreshToken } from "../react-cognito/index";
import navBarReducer from "./navBarReducer";
import contractsReducer from "./contractsReducer";
import addAnimalTypeReducer from "./addAnimalTypeReducer";
import breedCategoryReducer from "./breedCategoryReducer";
import breedAttributeReducer from "./breedAttributeReducer";
import addBreedTypeReducer from "./addBreedTypeReducer";
import regTypeReducer from "./regTypeReducer";
import medicalRecordsReducer from "./medicalRecordsReducer";
import administeredTypeReducer from "./administeredTypeReducer";
import userReducer from "./userReducer";
import breederReducer from "./breederReducer";
import addFormulaReducer from "./addFromulaReducer";
import petShopReducer from "./petShopReducer";
import customersReducer from "./customersReducer";
import howFindUsReducer from "./howFindUsReducer";
import contractTermsReducer from "./contractTermsReducer";
import paymentReducer from "./paymentReducer";
import configReducer from "./configReducer";
import paymentTypeReducer from "./paymentTypeReducer";
import wooLocationReducer from "./wooLocationReducer";
import wooStoreReducer from "./wooStoreReducer";
import changeLogReducer from "./changeLogReducer";
import foodTypeReducer from "./foodTypeReducer";
import notificationManagerReducer from "./notificationManagerReducer";
import socialMediaSubmissionsReducer from "./socialMediaSubmissionReducer";
// import checkBoxTableReducer from './checkBoxTableReducer';
import subscribeToPetReducer from "./subscribeToPetReducer";
import videoManagerReducer from "./videoManagerReducer";
import virtualVisitRequestReducer from "./virtualVisitRequestReducer";
import quizReducer from "./quizReducer";
import salesDashBoardReducer from "./salesDashboardReducer";
import breedSalesDashBoardReducer from  "./breedSalesDashboardReducer";

const allReducers = combineReducers({
  navBarReducer,
  contractsReducer,
  //  checkBoxTableReducer,
  addAnimalTypeReducer,
  breedCategoryReducer,
  addBreedTypeReducer,
  breedAttributeReducer,
  regTypeReducer,
  medicalRecordsReducer,
  administeredTypeReducer,
  breederReducer,
  userReducer,
  cognito,
  addFormulaReducer,
  form: formReducer,
  petShopReducer,
  customersReducer,
  contractTermsReducer,
  howFindUsReducer,
  configReducer,
  paymentReducer,
  paymentTypeReducer,
  wooStoreReducer,
  changeLogReducer,
  foodTypeReducer,
  notificationManagerReducer,
  socialMediaSubmissionsReducer, 
  subscribeToPetReducer,
  videoManagerReducer,
  virtualVisitRequestReducer,
  quizReducer,
  wooLocationReducer,
  salesDashBoardReducer,
  breedSalesDashBoardReducer,
});
const rootReducer = (state, action) => {
  if (action.type === "COGNITO_LOGOUT") {
    state = Object.assign(
      {},
      { cognito: state.cognito, petShopReducer: state.petShopReducer }
    );
  }
  return allReducers(state, action);
};
export default rootReducer;
